import React from 'react';
import './RefundPage.scss';

const RefundPage: React.FC = () => {
  return (
    <div className="policy-page refund-page">
      <div className="policy-page__container">
        <h1 className="policy-page__title">Refund & Return Policy</h1>
        <p className="policy-page__updated">Last updated: December 30, 2024</p>

        <div className="policy-page__intro">
          <p>
            Thank you for shopping with $HTROM. Please review our policy carefully 
            before making a purchase.
          </p>
        </div>

        <div className="policy-page__content">
          <section className="policy-page__section">
            <h2 className="policy-page__section-title">All Sales Are Final</h2>
            <p>
              Due to the nature of our products and limited releases, all sales are final. 
              We do not accept returns, refunds, or exchanges once an order has been placed.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Damaged or Defective Items</h2>
            <p>
              We only offer replacements or store credit if an item arrives damaged 
              or defective. To be eligible:
            </p>
            <ul className="policy-page__list">
              <li>Contact us within 48 hours of delivery</li>
              <li>Provide clear photos of the damage</li>
              <li>Item must be unused and in original condition</li>
            </ul>
            <p className="policy-page__note">
              Claims submitted after 48 hours may not be accepted. Cash refunds are 
              not guaranteed.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Non-Returnable Items</h2>
            <ul className="policy-page__list">
              <li>Worn or washed items</li>
              <li>Items damaged due to improper care</li>
              <li>Incorrect size selection</li>
              <li>Limited drop or sale items</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Shipping Issues</h2>
            <p>
              Once an order is marked as delivered, we are not responsible for lost, 
              stolen, or misdelivered packages. Please ensure your shipping address 
              is accurate before completing your order.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Order Cancellations</h2>
            <p>Orders cannot be canceled or modified once placed.</p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Contact</h2>
            <p className="policy-page__contact">
              <a href="mailto:support@shtromstudio.com">support@shtromstudio.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPage;
